import script from "./Coupons.vue?vue&type=script&setup=true&lang=js"
export * from "./Coupons.vue?vue&type=script&setup=true&lang=js"

import "./Coupons.vue?vue&type=style&index=0&id=78bb90c2&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78bb90c2"]])

export default __exports__